export default __webpack_public_path__ + "static/media/sponsor_1.94794fce.png";